import type { ScreenBase } from "@frui.ts/screens/dist";
import { Router } from "@frui.ts/screens/dist";
import { Modules } from "../../config";
import LocalizationService from "../../services/localizationService";
import SecurityService from "../../services/securityService";
import ChargeTypesViewModel from "./chargeTypes/chargeTypesViewModel";
import DistributorsViewModel from "./distributors/distributorsViewModel";
import ModuleViewModel from "../moduleViewModel";
import ReportingViewModel from "./reporting/reportingViewModel";
import ExemptionReasonsViewModel from "./exemptionReasons/exemptionReasonsViewModel";
import DistributorEnumsViewModel from "./distributorEnums/distributorEnumsViewModel";

@Router.registerRoute({
  route: Modules.timeCharges,
  name: Router.Self,
  children: [ExemptionReasonsViewModel, ChargeTypesViewModel, DistributorsViewModel, ReportingViewModel],
})
export default class TimeChargesViewModel extends ModuleViewModel<ScreenBase> {
  protected readonly module = Modules.timeCharges;

  constructor(
    protected localizationService: LocalizationService,
    private securityService: SecurityService,
    private chargeTypesViewModel: ChargeTypesViewModel,
    private distributorEnumsViewModel: DistributorEnumsViewModel,
    private exemptionReasonsViewModel: ExemptionReasonsViewModel,
    private distributorsViewModel: DistributorsViewModel,
    private reportingViewModel: ReportingViewModel
  ) {
    super();
    this.navigationName = this.module;

    if (this.securityService.allowTo("enums") || this.securityService.allowTo("finance.factualauditing", "write")) {
      this.children.push(this.chargeTypesViewModel);
    }
    if (this.securityService.allowTo("enums")) {
      this.children.push(this.distributorEnumsViewModel, this.exemptionReasonsViewModel);
    }

    if (this.distributorsViewModel.children.length) {
      this.children.push(this.distributorsViewModel);
    }

    if (this.securityService.allowTo("charges.reports")) {
      this.children.push(this.reportingViewModel);
    }
  }
}
